import { useState } from 'react'
import { saveProgressWithGoogle, sendMagicLink } from '../lib/user'
import { friendly } from '../lib/errors'

export const AUTH_BENEFITS: [string, string][] = [
  ['🔥', 'Keep your streak alive'],
  ['🏆', 'Claim your player name'],
  ['📊', 'Save your stats on any device'],
  ['🎁', 'Unlock free bonus games'],
]

/** The one sign-in surface. Opened from every "Sign up / Login" button. */
export function AuthModal({ onClose, nudge }: { onClose: () => void; nudge?: boolean }) {
  const [mode, setMode] = useState<'pick' | 'email' | 'sent'>('pick')
  const [email, setEmail] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const google = async () => {
    setBusy(true); setErr('')
    try { await saveProgressWithGoogle(); onClose() }
    catch (e) { setErr(friendly(e)); setBusy(false) }
  }
  const sendLink = async () => {
    setBusy(true); setErr('')
    try { await sendMagicLink(email.trim()); setMode('sent') }
    catch (e) { setErr(friendly(e)) }
    finally { setBusy(false) }
  }

  return (
    <div className="modal-veil" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" role="dialog" aria-modal="true" aria-label="Sign up or log in">
        <button className="modal-x" aria-label="close" onClick={onClose}>✕</button>
        {mode === 'sent' ? (
          <>
            <h2>Check your inbox 📬</h2>
            <p className="muted">We sent a sign-in link to <b>{email}</b>. Open it on this device and you're in — no password, ever.</p>
            <button className="btn ghost block" onClick={onClose}>Done</button>
          </>
        ) : (
          <>
            <h2>{nudge ? "You're not signed in" : 'Sign up / Login'}</h2>
            <ul className="benefits">
              {AUTH_BENEFITS.map(([e, t]) => <li key={t}><span>{e}</span>{t}</li>)}
            </ul>
            <p className="tiny">Skip it and your streak drifts off into space when you leave. 🚀</p>
            {mode === 'pick' ? (
              <div className="actions" style={{ marginTop: 8 }}>
                <button className="btn block" disabled={busy} onClick={google}>Sign up / Login with Google</button>
                <button className="btn ghost block" disabled={busy} onClick={() => setMode('email')}>Sign up / Login with email</button>
              </div>
            ) : (
              <div className="actions" style={{ marginTop: 8 }}>
                <input className="input" type="email" autoFocus placeholder="your@email.com" value={email}
                  onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && email.includes('@')) sendLink() }} />
                <button className="btn block" disabled={busy || !email.includes('@')} onClick={sendLink}>{busy ? 'Sending…' : 'Email me a sign-in link'}</button>
                <button className="btn ghost block" onClick={() => setMode('pick')}>Back</button>
              </div>
            )}
            {err && <p className="tiny" style={{ color: '#FF5C5C' }}>{err}</p>}
          </>
        )}
      </div>
    </div>
  )
}
